import React from 'react';
import { motion } from 'framer-motion';
export function Comparison() {
  const rows = [{
    sin: 'Horas planificando desde cero cada semana',
    con: '5 minutos. Todo listo.'
  }, {
    sin: 'Secuencias improvisadas sin progresión',
    con: '+150 secuencias organizadas por nivel'
  }, {
    sin: 'Grupos sin sistema claro',
    con: 'Estructura clara para cada nivel y objetivo'
  }, {
    sin: 'Miedo a que un alumno se lesione',
    con: '100 modificaciones listas para usar'
  }, {
    sin: 'Terminar cada clase emocionalmente agotado',
    con: 'Sistema de blindaje energético incluido'
  }, {
    sin: 'Sensación de improvisar siempre',
    con: 'Llegas a clase con todo resuelto'
  }];
  return <section className="py-20 px-4 bg-hueso" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-oscuro mb-12" data-id="element-55">
          ¿Cuánto cuesta NO tenerlo?
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-md overflow-hidden mb-12" data-id="element-56">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-100" data-id="element-57">
            <div className="p-4 md:p-6 text-center font-bold text-gray-500 text-sm md:text-lg" data-id="element-58">
              Sin YOGA 360
            </div>
            <div className="p-4 md:p-6 text-center font-bold text-salvia text-sm md:text-lg bg-salvia-light/30" data-id="element-59">
              Con YOGA 360
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-60">
            {rows.map((row, idx) => <div key={idx} className="grid grid-cols-2" data-id="element-61">
                <div className="p-4 md:p-6 text-gray-600 text-sm md:text-base flex items-center justify-center text-center" data-id="element-62">
                  {row.sin}
                </div>
                <div className="p-4 md:p-6 text-oscuro font-medium text-sm md:text-base flex items-center justify-center text-center bg-salvia-light/10" data-id="element-63">
                  {row.con}
                </div>
              </div>)}
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-xl md:text-2xl font-bold text-oscuro leading-relaxed" data-id="element-64">
          El lunes puedes improvisar
          <br data-id="element-65" />o entrar con todo resuelto.
          <br data-id="element-66" />
          Tú decides.
        </motion.p>
      </div>
    </section>;
}